import { mainAxios } from "../../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "../mainService";

export const createSolicitud = async (request) => {
  try {
    const response = await mainAxios.post(
      `v1/solicitud/insert/`,
      request,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSolicitudById = async (id) => {
  try {
    const response = await mainAxios.get(
      `v1/solicitud/id/${id}`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const postReadCorreo = async (body) => {
  try {
    const response = await mainAxios.post(
      `v1/secretManager/read/email`,
        body,  
        getDefaultHeaders()  
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


export const getSolicitudesFiltrosAreaNegocio = async (filters, elementosPagina, pagina, areaNegocioId, order = 'ASC') => {
  try {
    const response = await mainAxios.get(
      `v1/solicitudes/filters/area_negocio`, 
      {
        ...getDefaultHeaders(),
        params: {
          filters: JSON.stringify(filters), 
          limit:elementosPagina,
          page: pagina,
          areaNegocioId: areaNegocioId,
          order:order
        },
        
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const putUpdateSolicitudesByuuid = async (uuid, request) => {
  try {
    const response = await mainAxios.put(
      `/v1/solicitud/update/${uuid}`, 
      request,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createSolicitudRedencion = async (request) => {
  try {
    const response = await mainAxios.post(
      `v1/solicitud/redencion/insert/`,
      request,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createSolicitudRedencionAlianza = async (request, alianzaId) => {
  try {
    const response = await mainAxios.post(
      `v1/solicitud/redencion/${alianzaId}/insert/`,
      request,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createSolicitudRedencionSinEmision = async (body) => {
  try {
    const response = await mainAxios.post(
      `v1/solicitud/redencion/sin-emision`,
      body,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}

export const getStatusList = async () => {
  try {
    const response = await mainAxios.get(
      `v1/status/solicitudes/list`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


export const getTipoSolicitudesForAlianzaId = async (alianzaId) => {
  try {
    const response = await mainAxios.get(
      `v1/tipoSolicitud/list/${alianzaId}`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const createSolicitudSiniestro = async (request) => {
  try {
    const response = await mainAxios.post(
      `v1/solicitud/siniestro/insert/`,
      request,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const retrySolicitudRedencion = async (request, solicitudId) => {
  try {
    const response = await mainAxios.put(
      `v1/solicitud/redencion/update/` + solicitudId,
      request,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const retrySolicitudRedencionGenerica = async (request, solicitudId, alianzaId) => {
  const response = await mainAxios.put(
    `v1/solicitud/redencion/${alianzaId}/update/${solicitudId}`,
    request,
    getDefaultHeaders()
  );

  return response.data;
};

export const aprobarRechazarRedencionExcepcion = async (request, solicitudId, alianzaId) => {
  const response = await mainAxios.put(
    `v1/solicitud/redencion/${alianzaId}/update/${solicitudId}`,
    request,
    getDefaultHeaders()
  );

  return response.data;
};

export const redimirFolioManualGenerico = async (body, route_id, alianzaId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    },
  };

  return mainAxios.put(`/v1/solicitud/redencion/${alianzaId}/update/${route_id}`, body, config);

};
